/* BlankApparel — ba-vibe.js: small feel-good touches. Loaded by sections/ba-extras.liquid.
   1. Welcome toast once per session for logged-in customers.
   2. Add-to-cart celebration: any successful /cart/add call shows a toast with pieces + total and bumps the header count.
   3. Moves the dealer cart note (template cart) and the one-tap reorder card (account page) into place. */
(function () {
  'use strict';
  var BA = (window.BA = window.BA || {});
  var money = function (c) { return window.BA_MONEY ? BA_MONEY(c) : '₹' + Math.round(c / 100).toLocaleString('en-IN'); };

  function toast(html, ms) {
    var t = document.querySelector('.ba-toast');
    if (!t) { t = document.createElement('div'); t.className = 'ba ba-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); document.body.appendChild(t); }
    t.innerHTML = html; t.classList.add('is-in');
    clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove('is-in'); }, ms || 4200);
  }
  BA.toast = toast;

  /* 1. Welcome, once per session */
  var hello = document.querySelector('[data-ba-hello]');
  if (hello) {
    try {
      if (!sessionStorage.getItem('ba_hello')) { sessionStorage.setItem('ba_hello', '1'); setTimeout(function () { toast(hello.innerHTML, 5200); }, 900); }
    } catch (e) {}
  }

  /* 2. Add-to-cart celebration */
  function bumpCount(n) {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    var b = icon.querySelector('.ba-cart-count');
    if (!b) { b = document.createElement('span'); b.className = 'ba-cart-count'; b.setAttribute('aria-hidden', 'true'); icon.appendChild(b); }
    b.textContent = n < 100 ? n : '99';
    b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump');
  }
  var of = window.fetch;
  if (of) {
    window.fetch = function (u, o) {
      var p = of.apply(this, arguments);
      try {
        var url = typeof u === 'string' ? u : (u && u.url) || '';
        if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
          p.then(function (r) {
            if (!r.ok) return;
            of('/cart.js', { headers: { Accept: 'application/json' } }).then(function (x) { return x.json(); }).then(function (c) {
              bumpCount(c.item_count);
              var dealer = document.documentElement.hasAttribute('data-ba-dealer');
              toast('<b>Added to your cart 🎉</b><span>' + c.item_count + ' pcs in cart · ' + money(c.total_price) + (dealer ? ' list · dealer price applies at checkout' : ' + GST') + '</span>', 4200);
            }).catch(function () {});
          }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  /* 3a. Dealer cart note */
  var note = document.querySelector('[data-ba-cartnote]');
  if (note) {
    var foot = document.querySelector('#main-cart-footer .page-width, .cart__footer, #main-cart-footer, #MainContent');
    if (foot) { foot.insertBefore(note, foot.firstChild); note.hidden = false; }
  }

  /* 3b. One-tap reorder on the account page */
  var re = document.querySelector('[data-ba-reorder]');
  if (re) {
    var host = document.querySelector('.customer.account, .customer, #MainContent');
    if (host) { host.insertBefore(re, host.firstChild); re.hidden = false; }
    var btn = re.querySelector('[data-reorder]');
    if (btn) btn.addEventListener('click', function () {
      var items = [];
      try { items = JSON.parse(re.getAttribute('data-items') || '[]'); } catch (e) {}
      if (!items.length) return;
      btn.disabled = true; btn.textContent = 'Adding…';
      of('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add'); return j; }); })
        .then(function () { btn.textContent = 'Added ✓'; setTimeout(function () { window.location.href = '/cart'; }, 900); })
        .catch(function (e) { btn.disabled = false; btn.textContent = 'Reorder in one tap'; toast('<b>Could not reorder</b><span>' + (e.message || 'A size may be sold out. Open the product to adjust.') + '</span>', 5000); });
    });
  }
})();
